export enum GameDataCySelector {
    GAME_SUMMARY_TAB = 'game-summary-tab',
    GAME_VIDEO_TAB = 'game-video-tab',
    GAME_REPORT_TAB = 'game-report-tab',
    GAME_BOXSCORE_TAB = 'game-boxscore-tab'
}
